module.exports = __webpack_public_path__ + "img/2.0a508f03.jpg";